var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon For Close"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)","fill":"#000000"},[React.createElement("rect",{"x":"0","y":"7","width":"16","height":"2","rx":"1","key":0}),React.createElement("rect",{"opacity":"0.3","transform":"translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) ","x":"0","y":"7","width":"16","height":"2","rx":"1","key":1})]))]);
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Close;

Close.default = Close;
